import React from "react";
import { Image, PlayerListElement } from "../../../../client/api";
import TopScorerPanel from "./TopScorerPanel";

type TopScorerProps = {
  player1?: PlayerListElement | null;
  player2?: PlayerListElement | null;
  emblem1?: Image;
  emblem2?: Image;
  goals1?: number;
  goals2?: number;
};


const RightPanel: React.FC<Partial<TopScorerProps>> = ({ player1, player2, emblem1, emblem2, goals1, goals2 }) => (
  <div className="flex flex-col gap-4">
    {(player1 || player2 || emblem1 || emblem2) && (
      <TopScorerPanel player1={player1} player2={player2} emblem1={emblem1} emblem2={emblem2} goals1={goals1}
                      goals2={goals2} />
    )}
  </div>
);

export default RightPanel;


